export default {
  inserted (el, bindings) {
    const { value } = bindings

    if (!value) return

    const img = new Image()

    img.onload = () => {
      el.innerText = `${img.width}×${img.height}`
    }

    img.src = value
  }
}
